import { useAdvertContactsState, useAdvertContactsLoadContext } from '#advertContacts/hooks';

const AdvertContactsWrapper = () => {
  const { isLoaded } = useAdvertContactsState();
  const { AdvertContacts } = useAdvertContactsLoadContext();

  if (!isLoaded) {
    return null;
  }

  return <AdvertContacts />;
};

export { AdvertContactsWrapper };
